import React from "react";
import { useTranslation } from "react-i18next";
import heroImage from "../assets/img/hero-carousel/hero-carousel-1.jpg";

/**
 * Full-height hero on the home page; `compact` gives sub-pages a shorter banner
 * so their content starts within the first screen on phones.
 */
const Hero = ({ compact = false }) => {
  const { t } = useTranslation();
  const Title = compact ? "h2" : "h1";

  return (
    <div id="hero" className={`hero ${compact ? "hero--compact" : ""}`}>
      <img className="hero__media" src={heroImage} alt="" decoding="async" />
      <div className="info d-flex align-items-center">
        <div className="container">
          <div className="row justify-content-center" data-aos="fade-up" data-aos-delay="100">
            <div className="col-12 col-lg-8 col-xl-6 text-center">
              <Title className="hero__title">{t("key-company-Name.title")}</Title>
              <a href="#get-started" className="btn-get-started">
                {t("key-company-Name.cta")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
